<template>
  <div class="app-container">
    <!-- 1. 顶部筛选栏 -->
    <div class="filter-container">
      <div class="filter-item">
        <span class="label">{{ $t('newOrder.createTime') }}</span>
        <el-date-picker
          v-model="timeValue"
          :clearable="false"
          :default-time="['00:00:00', '23:59:59']"
          :format="$i18n.locale == 'zh' ? zhDate : ptDate"
          :placeholder="$t('newOrder.SelectDatetime')"
          range-separator="~"
          style="width: 300px"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </div>
      <div class="filter-item">
        <span class="label">{{ $t('newOrder.CustomerName') }}</span>
        <el-select
          v-model="queryParams.customerId"
          :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
          :remote-method="getCustomerPage"
          clearable
          filterable
          remote
          reserve-keyword
          @focus="getCustomerPage('')"
        >
          <el-option
            v-for="(item, index) in customerList"
            :key="index"
            :label="item.customerAlias + '（' + item.username + '）'"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="filter-item">
        <span class="label">{{ $t('newOrder.SenderState') }}</span>
        <el-select
          v-model="queryParams.senderStateList"
          :placeholder="$t('GlobalSetObj.pleaseChoose')"
          clearable
          filterable
          multiple
        >
          <el-option
            v-for="item in StateList"
            :key="item.id"
            :label="item.label"
            :value="item.label"
          />
        </el-select>
      </div>
      <div class="filter-actions">
        <el-button
          icon="el-icon-search" size="small" type="primary"
          @click="getSearch"
        >{{ $t('newOrder.search') }}
        </el-button>
        <el-button size="small" @click="handleReset">{{ $t('newOrder.reset') }}</el-button>
        <el-radio-group v-model="queryParams.isTest" size="small" style="margin: 0 10px">
          <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
          <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
        </el-radio-group>
        <el-button
          icon="el-icon-upload2" size="small" type="primary"
          @click="exportFun"
        >{{ $t('newOrder.export') }}
        </el-button>
      </div>
    </div>
    <!-- 2. 实时总数/预警卡片 -->
    <el-row :gutter="20" class="summary-row">
      <!-- 实时总数 (绿框) -->
      <el-col :span="7">
        <div class="stat-card summary-card border-green">
          <div class="card-title text-green">{{ $t('tablePrice.realtimeTotal') }}</div>
          <div class="card-body">
            <div class="main-stat">
              <span class="stat-label">{{ $t('tablePrice.pendingPickupTotal') }}</span>
              <span class="stat-number text-red">{{ resultData.totalQuantity || 0 }}</span>
            </div>
            <div class="sub-stat bg-pink">
              <span>{{ $t('tablePrice.todayNewPendingPickup') }}</span>
              <span class="text-red font-bold">+{{ resultData.today || 0 }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <!-- 超7天 (红框) -->
      <el-col :span="4">
        <div class="stat-card warn-card border-red bg-pink">
          <div class="card-content">
            <div class="warn-label">{{ $t('tablePrice.over7Days') }}</div>
            <div class="warn-desc">{{ $t('tablePrice.notPickedUpCount') }}</div>
            <div class="warn-number text-red">{{ resultData.overSevenDays || 0 }}</div>
          </div>
        </div>
      </el-col>
      <!-- 7天内-3天前 (红框) -->
      <el-col :span="4">
        <div class="stat-card warn-card border-red bg-pink">
          <div class="card-content">
            <div class="warn-label">{{ $t('tablePrice.within7DaysTo3DaysAgo') }}</div>
            <div class="warn-desc">{{ $t('tablePrice.notPickedUpCount') }}</div>
            <div class="warn-number text-red">{{ resultData.threeDaysBefore || 0 }}</div>
          </div>
        </div>
      </el-col>
      <!-- 3天内-1天前 (红框) -->
      <el-col :span="4">
        <div class="stat-card warn-card border-red bg-pink">
          <div class="card-content">
            <div class="warn-label">{{ $t('tablePrice.within3DaysTo1DayAgo') }}</div>
            <div class="warn-desc">{{ $t('tablePrice.notPickedUpCount') }}</div>
            <div class="warn-number text-red">{{ resultData.oneDaysBefore || 0 }}</div>
          </div>
        </div>
      </el-col>

      <!-- 当天 (绿框) -->
      <el-col :span="5">
        <div class="stat-card warn-card border-green bg-light-green">
          <div class="card-content">
            <div class="warn-label">{{ $t('tablePrice.currentDay') }}</div>
            <div class="warn-desc">{{ $t('tablePrice.notPickedUpCount') }}</div>
            <div class="warn-number text-green">{{ resultData.today || 0 }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 3. 各大区明细 -->
    <div class="region-section">
      <div class="section-header text-green font-bold">
        {{ $t('tablePrice.pendingPickupByRegion') }}
      </div>
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in regionData"
          :key="index"
          :span="6"
          style="margin-bottom: 20px"
        >
          <div class="region-card border-green">
            <div class="region-name font-bold">{{ item.name }}</div>
            <div class="region-stat">
              <span class="stat-label">{{ $t('tablePrice.pendingPickupWaybillPackage') }}</span>
              <span class="stat-number text-green">{{ item.pendingCount }}</span>
            </div>
            <div class="region-stat">
              <span class="stat-label">{{ $t('tablePrice.orderCustomerCount') }}</span>
              <span class="stat-number text-green">{{ item.customerCount }}</span>
            </div>
            <div v-if="item.customerCount > 0 || item.pendingCount > 0" class="region-footer">
              <i class="el-icon-bottom text-green" @click="handleExport(item)" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { bulkyWasteCollectBoardQuery, getLgAreaListData } from '@/api/orderApi';
import dayjs from 'dayjs';
import { apiCustomerPage } from '@/api/customer';
import { goResourceTaskList } from '@/utils/goExportList';
import { waybillExportAll } from '@/api/bulkExpressApi';

export default {
  name: 'PickupDashboard',
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      customerList: [],
      StateList: [],
      // 查询参数
      queryParams: {
        customerId: '',
        senderStateList: [],
        isTest: 1
      },
      // 各大区数据 (造假数据)
      regionData: [],
      resultData: {}
    };
  },
  mounted() {
    this.getTimer();
    this.getSearch();
    this.getAddress();
  },
  methods: {
    // 获取订单日志
    getSearch() {
      const data = {
        beginTime: '',
        endTime: '',
        customerId: this.queryParams.customerId,
        orderWaybillType: this.queryParams.isTest,
        senderStateList: this.queryParams.senderStateList
      };
      if (this.timeValue && this.timeValue.length > 0) {
        data.beginTime = this.timeValue[0];
        data.endTime = this.timeValue[1];
      } else {
        this.$message.error(this.$t('tablePrice.selectTimeRange'));
        return;
      }
      bulkyWasteCollectBoardQuery(data).then((res) => {
        if (res.code === 200) {
          console.log(res, '===res');
          this.resultData = res.data;
          this.regionData = [
            {
              name: this.$t('tablePrice.saopauloRegion'),
              pendingCount: res.data.santaCruz,
              customerCount: res.data.santaCruzCustomer,
              regionId: 1
            },
            {
              name: this.$t('tablePrice.southeastRegion'),
              pendingCount: res.data.southeast,
              customerCount: res.data.southeastCustomer,
              regionId: 3
            },
            {
              name: this.$t('tablePrice.southRegion'),
              pendingCount: res.data.south,
              customerCount: res.data.southCustomer,
              regionId: 4
            },
            {
              name: this.$t('tablePrice.northRegion'),
              pendingCount: res.data.north,
              customerCount: res.data.northCustomer,
              regionId: 5
            },
            {
              name: this.$t('tablePrice.northeastRegion'),
              pendingCount: res.data.northeast,
              customerCount: res.data.northeastCustomer,
              regionId: 6
            },
            {
              name: this.$t('tablePrice.northwestRegion'),
              pendingCount: res.data.northwest,
              customerCount: res.data.northwestCustomer,
              regionId: 7
            },
            {
              name: this.$t('tablePrice.midwestRegion'),
              pendingCount: res.data.centralWest,
              customerCount: res.data.centralWestCustomer,
              regionId: 8
            }
          ];
        }
      });
    },
    // 点击导出
    handleExport(row) {
      console.log(row, 'handleExport');
      const data = {
        senderStateList: this.queryParams.senderStateList || [],
        customerId: this.queryParams.customerId || null,
        orderWaybillType: this.queryParams.isTest,
        createBeginTime: '',
        createEndTime: '',
        receiverRegionId: row.regionId,
        cargoOrderStatus: [2, 30]
      };
      if (this.timeValue && this.timeValue.length > 0) {
        data.createBeginTime = this.timeValue[0];
        data.createEndTime = this.timeValue[1];
      } else {
        this.$message.error(this.$t('tablePrice.selectTimeRange'));
        return;
      }
      waybillExportAll(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    exportFun() {
      const data = {
        createBeginTime: '',
        createEndTime: '',
        customerId: this.queryParams.customerId,
        orderWaybillType: this.queryParams.isTest,
        senderStateList: this.queryParams.senderStateList,
        cargoOrderStatus: [2, 30]
      };
      if (this.timeValue && this.timeValue.length > 0) {
        data.createBeginTime = this.timeValue[0];
        data.createEndTime = this.timeValue[1];
      } else {
        this.$message.error(this.$t('tablePrice.selectTimeRange'));
        return;
      }
      waybillExportAll(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    handleReset() {
      this.queryParams = {
        customerId: '',
        senderStateList: [],
        isTest: 1
      };
      this.getTimer();
      this.getSearch();
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 获取最近一个月时间（巴西时区）
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime); // 今天（巴西时间）
      // 关键：减去 1 个月
      const oneMonthAgo = today.subtract(1, 'month').format('YYYY-MM-DD');
      const endDate = today.format('YYYY-MM-DD');
      // 赋值：一个月前 0点 → 今天 23:59:59
      this.timeValue = [oneMonthAgo + ' 00:00:00', endDate + ' 23:59:59'];
    }
  }
};
</script>

<style scoped>
/* 通用布局 */
.filter-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 20px;
}

.filter-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.filter-item .label {
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
  font-weight: bold;
}

.filter-actions {
  display: flex;
  align-items: center;
}

/* 颜色工具类 */
.text-red {
  color: #e16363;
}

.text-green {
  color: #01a122;
  cursor: pointer;
}

.font-bold {
  font-weight: bold;
}

.border-green {
  border: 1px solid #01a122;
}

.border-red {
  border: 1px solid #e16363;
}

.bg-pink {
  background-color: #fef0f0;
}

.bg-light-green {
  background-color: #f0f9eb;
}

/* 统计卡片 (第一行) */
.summary-row {
  margin-bottom: 20px;
}

.stat-card {
  max-height: 170px;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
}

/* 左侧总结卡片 */
.summary-card {
  max-height: 170px;
}

.card-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: -8px;
}

.card-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.main-stat {
  text-align: center;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 15px;
  color: black;
  margin-right: 15px;
  font-weight: bold;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
}

.sub-stat {
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 5px;
  color: #e16363;
  font-weight: bold;
}

/* 预警卡片 (右侧) */
.warn-card {
  max-height: 170px;
  text-align: center;
  justify-content: center;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.warn-label {
  font-size: 15px;
  color: black;
  margin-bottom: 5px;
  font-weight: bold;
}

.warn-desc {
  font-size: 14px;
  color: black;
  margin-bottom: 10px;
}

.warn-number {
  font-size: 24px;
  font-weight: bold;
}

/* 大区卡片区域 */
.region-section {
  border: 1px solid #e4e7ed;
  padding: 15px;
  border-radius: 8px;
}

.section-header {
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: bold;
}

.region-card {
  padding: 15px;
  border-radius: 8px;
  max-height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  background-color: #fff;
}

.region-name {
  text-align: center;
  margin: 15px 0;
  font-size: 16px;
}

.region-stat {
  display: flex;
  justify-content: space-between;
  padding: 3px 15px;
  margin-bottom: 5px;
}

.region-stat .stat-label {
  font-size: 15px;
}

.region-stat .stat-number {
  font-size: 20px;
}

.region-footer {
  position: absolute;
  bottom: -2px;
  right: 1px;
}

.region-footer i {
  font-size: 18px;
}
</style>
